import style from "./style/home.module.css";
import Menu from "./components/Menu";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CadastroGasto from "./screen/cadastroGasto";
import CadastroReceita from "./screen/cadastroReceita";
import Home from "./screen/home";
import Saldo from "./components/Saldo";
import { Methods } from "./function/method_desp_rec";
import Politica from "./screen/politica";
import Acumulator from "./screen/acumulator";
import Info from "./screen/info";

function App() {
  return (
    <Methods>
      <BrowserRouter>
        <div className={style.corFundo}>
          <Menu />

          {/* <Saldo/> */}

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gasto" element={<CadastroGasto />} />
            <Route path="/receita" element={<CadastroReceita />} />
            <Route path="/politica" element={<Politica />} />
            <Route path="/juntar" element={<Acumulator />} />
            <Route path="/informacoes" element={<Info/>}/>
          </Routes>
        </div>
      </BrowserRouter>
    </Methods>
  );
}

export default App;
